<template>
  <v-dialog
    v-model="show"
    scrollable
    persistent
    :overlay="false"
    min-width="500px"
  >
    <v-card>
      <v-toolbar dark color="#E3002C" class="d-flex align-center">
        <v-btn icon dark @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-toolbar>
            <v-spacer></v-spacer>
            <v-autocomplete
              label="Medio de Pago"
              :items="paymentFormItems"
              hide-details
              hide-no-data
              hide-selected
              :item-text="getPaymentFormText"
              item-value="url"
              return-object
              @change="paymentFormSelected($event)"
              ref="paymentFormAutocomplete"
              prepend-icon="mdi-close"
              @click:prepend="clearAutocomplete('paymentFormAutocomplete')"
            ></v-autocomplete>
            <v-spacer></v-spacer>
            <!-- eslint-disable -->
            <v-text-field
              hide-details
              v-model="search"
              append-icon="mdi-magnify"
              :label="searchLabel + (disableIntellySearch ? ' (presione Enter para Ejecutar Búsqueda...)' : '')"
              @keydown.enter.prevent="paymentConditionReadDataFromAPI(true)"
            ></v-text-field>
            <!-- eslint-enable -->
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-card>
        <v-card>
          <v-data-table
            dense
            v-bind:page="page"
            :pageCount="this.pageCount"
            :loading="loading"
            :headers="headers"
            :items="items"
            :itemsPerPage="itemsPerPage"
            :serverItemsLength="serverItemsLength"
            :options.sync="options"
            @click:row="onClickRow"
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer
                :pagination="pagination"
                :options="options"
                @update:options="updateOptions"
              />
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "PaymentConditionSearchDialog",

  props: {
    show: {
      type: Boolean,
      default: false
    },
    order: {
      type: Object,
      default: null
    },
    disableInterest: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      title: "Búsqueda de Condición de Pago",
      endpoint: "/data/payment_condition_with_interest/",
      loading: true,
      page: 1,
      serverItemsLength: 0,
      pageCount: 0,
      itemsPerPage: 100,
      options: {},
      search: "",
      headers: [
        {
          text: "Condición de Pago",
          value: "payment_condition.description",
          sortable: false
        },
        {
          text: "Medio de Pago",
          value: "payment_condition.payment_form_object.description",
          sorteable: false
        }
      ],
      items: [],
      paymentFormItems: [],
      filterPaymentForm: null,
      mounting: true,
      disableIntellySearch: this.$bRoot.getUserParam("disableIntellySearch"),
      searchLabel: "Condición de Pago (Código / Descripción)"
    };
  },

  //this one will populate new data set when user changes current page.
  watch: {
    options: {
      handler() {
        this.paymentConditionReadDataFromAPI(false);
      }
    },
    /* en función de disable auto search */
    search: {
      handler() {
        if (!this.disableIntellySearch) {
          this.paymentConditionReadDataFromAPI(true);
        }
      }
    },
    deep: true
  },

  methods: {
    onClose() {
      this.$emit("cancel");
    },
    onClickRow(item) {
      this.$emit("itemSelected", item.payment_condition);
    },

    paymentFormSelected(item) {
      this.filterPaymentForm = item;
      this.paymentConditionReadDataFromAPI(true);
    },

    clearAutocomplete(field) {
      this.$refs[field].internalValue = [];
      switch (field) {
        case "paymentFormAutocomplete":
          this.filterPaymentForm = null;
          break;
      }
      this.paymentConditionReadDataFromAPI(true);
    },

    async loadPaymentForms() {
      this.filterPaymentForm = null;
      this.paymentFormItems = [];

      let paymentForms = await this.$bRoot.search(
        "/data/payment_forms",
        null,
        "description",
        null
      );

      this.paymentFormItems = paymentForms.data.results;
    },

    getPaymentFormText(item) {
      return item.code + " - " + item.description;
    },

    //Reading data from API method.
    async paymentConditionReadDataFromAPI(reset) {
      try {
        const { page, itemsPerPage } = this.options;
        let pageNumber = reset ? 1 : page;
        /*eslint-disable */
        let search = (this.search ? this.search.replace(/[^a-zA-Z0-9]+/g, "_") : "_");
        let endpoint =
          this.endpoint +
          (this.order.crop_object ? this.order.crop_object.id.toString() : "0") +
          "/" +
          (this.order ? this.order.date : this.$bRoot.moment().format("YYYY-MM-DD")) +
          "/" +
          (this.filterPaymentForm ? this.filterPaymentForm.id.toString() : "0") +
          "/" +
          search;
        /*eslint-enable */

        let res = await this.$bRoot.search(
          endpoint,
          null,
          null,
          null,
          pageNumber
        );
        if (this.$bRoot.errors) {
          throw "Error recuperando datos";
        }
        if (res) {
          let payment_conditions = res.data.results.map(object => {
            object.payment_condition.interest = object.interest;
            return object;
          });
          this.items = payment_conditions;
          this.serverItemsLength = res.data.count;
          this.page = pageNumber;
          this.pageCount = Math.ceil(res.data.count / itemsPerPage);
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.loading = false;
      }
    }
  },

  async mounted() {
    try {
      if (!this.disableInterest) {
        this.headers.push({
          text: "Interés General",
          value: "interest",
          sorteable: false
        });
      }

      //load payment forms
      await this.loadPaymentForms();

      //load data
      this.paymentConditionReadDataFromAPI(true);
    } catch (error) {
      if (!this.$bRoot.errors) {
        this.$bRoot.setError(error);
      }
    } finally {
      this.mounting = false;
    }
  }
};
</script>
<style scoped>
.v-data-table {
  margin-top: 0px;
}
</style>
